//#region import function
import React from 'react';
import propTypes from 'prop-types';
import { returnAvatarList } from '../../../../utils/consts/avatar';
//#endregion
//#region Function component to render avatar modal
const AvatarModal = (props) => {
  return (
    <div
      className="tab-pane fade show active"
      // id="avatar"
      // data-backdrop="false"
      // role="tabpanel"
      // aria-labelledby="avatar-tab"
    >
      <div className="d-flex flex-row flex-wrap">
        {returnAvatarList().map((item, index) => {
          return (
            <div key={index} className="col-2 p-0 m-0">
              <div
                // data-dismiss="modal"
                className={'d-flex py-2'}
                onClick={() => props.changeAvatar(item)}
              >
                {item.includes('.png') && (
                  <img
                    src={require(`../../../../content/images/avatars/${item}`)}
                    style={{
                      width: props.avatarSize,
                      height: props.avatarSize,
                    }}
                    alt="avatars"
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
//#endregion
//#region PropTypes
AvatarModal.prototype = {
  avatarSize: propTypes.number,
  changeAvatar: propTypes.func,
};
//#endregion
//#region  defaultProps
AvatarModal.defaultProps = {
  avatarSize: 50,
  changeAvatar: () => {
    console.error("Avatar Modal  component hasn't justFilter function");
  },
};
//#endregion
export default AvatarModal;
